import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FormField, Grid, Select, Text, TextArea, TextInput } from "grommet";
import * as React from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import Flag from "../components/Flag";
import NavigateToPath from "../components/NavigateToPath";
import ThemeBuilder from "../components/ThemeBuilder";
import OrganizationSearch from "../organizations/OrganizationSearch";
import { Organization } from "../organizations/OrganizationStore";
import MapDetails from "./MapDetails";
import { createMap, CreateMapRequest } from "./MapsStore";

const CreateMap = () => {
    let [organization, setOrganization] = React.useState({} as Organization);

    let [map, setMap] = React.useState({} as CreateMapRequest);

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    let navigate = useNavigate();

    let create = () => {
        setIsCreating(true);
        createMap(map).then(
            (result) => {
                navigate(`/admin/maps/${result.result.id}`,{replace:true});
            },
            (error) => {
                setError(error);
            }
        );
    };

    const onChange = (map) => {
        setMap({ ...map, organizationID: organization.id });
    };

    React.useEffect(() => {
        setMap({ ...map, organizationID: organization.id });
    }, [organization.id]);

    return (
        <div>
            <Box direction="row">
                <h1>Add Map </h1>
                <NavigateToPath path="admin/maps/create"></NavigateToPath>
            </Box>
            <Box width={{ max: "400px" }} pad="small" round="5px" background={"background"}>
                <OrganizationSearch onSelect={(organization) => setOrganization(organization)}></OrganizationSearch>
                <MapDetails map={map} isBusy={isCreating} onChange={onChange}></MapDetails>
                <br />
                <Box direction="row">
                    {/* @ts-ignore */}
                    <CustomButton primary icon={<FontAwesomeIcon size="xl" icon={["fad", "users-medical"]}></FontAwesomeIcon>} onClick={create} disabled={isCreating || !map.name || !map.content || !map.organizationID} label="Create"></CustomButton>
                </Box>

                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default CreateMap;
